import React from 'react';
import { Link } from 'react-router-dom';

import './brand-item-style.scss';

import Typography from '@src/componentsNew/Typography/Typography';
import ChevronRightIcon from '@src/componentsNew/Icons/Icons/ChevronRightIcon';
import TagIcon from '@src/componentsNew/Icons/Icons/TagIcon';

const BrandItem = ({ isMobile, brand }) => {
  return (
    <Link className="search-brand-item" to={brand?._source?.url}>
      <div className="search-brand-item-content">
        {/* TODO : Add brand image */}
        <div className={`search-brand-item-image-wrapper ${isMobile ? 'mobile' : ''}`}>
          <TagIcon width={isMobile ? '24' : '35'} height={isMobile ? '24' : '35'} />
        </div>

        <Typography variant="body2" component="span" style={{ color: '#090A0FDE' }}>
          {brand?._source?.name}
        </Typography>
      </div>

      <ChevronRightIcon />
    </Link>
  );
};

export default BrandItem;
